import { render, staticRenderFns } from "./RotatingLogo.vue?vue&type=template&id=22d30d9a&scoped=true&"
import script from "./RotatingLogo.vue?vue&type=script&lang=js&"
export * from "./RotatingLogo.vue?vue&type=script&lang=js&"
import style0 from "./RotatingLogo.vue?vue&type=style&index=0&id=22d30d9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d30d9a",
  null
  
)

export default component.exports